<div class="page-wrapper view-wrapper">

  <div class="d-none d-print-block page-header">
    <img alt="Core logo" class="navbar-logo"
         [src]="logoUrl | cdn" />
  </div>

  <div class="page-inner site-wrapper">

    <div class="page-content-wrapper wrapper site-content">
      <main
        [ngClass]="{'page-content--no-hero': isTopNavTransparent && (!heroImagesEnabled || (page && !page.meta.icon) || (post && !post.data.image)) }"
        class="page-content container-fluid p-0 mobile-padding category-{{category || 'default'}}" #main
        id="main-content" tabindex="0">
        <ng-container *ngIf="(page && page.meta.icon) || (post && post.data.image)">
          <div class="header-block">
            <!-- Hero image for all pages that aren't Home and a Life Moments/Journey pages.
            Uses just one main image which can be positioned using iconAlign meta for background-position. -->
            <div *ngIf="heroImagesEnabled"
                 [ngStyle]="{ backgroundPosition: page && page.meta.iconAlign ? page.meta.iconAlign : 'center center' }"
                 [style.background-image]="getBackgroundImage() | cdnBackground"
                 class="header-image">
              <div [ngClass]="{'loaded': delayedLoaded}" class="header-overlay"></div>
            </div>
          </div>
        </ng-container>

        <div [class]="containerClass">
          <router-outlet></router-outlet>
        </div>

      </main>
    </div>

  </div>

</div>

